<template>
  <Teleport to="body" :disabled="inline">
    <div v-if="id" :class="inline ? 'certificate-selection' : 'modal fade'" tabindex="-1" :id="id">
      <div :class="inline ? '' : 'modal-dialog modal-dialog-centered certificate-dialog'">
        <div :class="inline ? '' : 'modal-content'">
          <div class="modal-header">
            <h5 class="modal-title">Assinatura do documento</h5>
            <button v-if="!inline" type="button" class="btn btn-icon btn-sm btn-light" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
          <div class="modal-body">
            <p class="certificate-hint">Escolha como deseja finalizar o documento.</p>
            <div class="certificate-options">
              <button v-for="certifier in certifiers" :key="certifier.id" type="button"
                      class="certificate-option" :class="{ 'is-selected': selectedCertifier === certifier.id }"
                      :disabled="disabled" :aria-pressed="selectedCertifier === certifier.id"
                      :data-bs-dismiss="inline ? null : 'modal'" @click="go(certifier)">
                <span class="certificate-option__icon" aria-hidden="true"><i :class="optionDetails(certifier).icon"></i></span>
                <span class="certificate-option__text">
                  <strong>{{ optionDetails(certifier).title }}</strong>
                  <span>{{ optionDetails(certifier).description }}</span>
                </span>
                <i class="bi bi-chevron-right certificate-option__arrow" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>

export default {
  name: "SelectCertifier",
  emits: ["onSelect"],
  props: {
    id: String,
    inline: Boolean,
    disabled: Boolean,
    certifiers: Array,
  },
  data() {
    return {
      selectedCertifier: "",
    }
  },
  mounted() {
    this.selectedCertifier = this.$store.state.auth.certifier?.id ?? "";
  },
  methods: {
    optionDetails(certifier) {
      const options = {
        vidaas: { title: 'VidaaS', description: 'Assinar com certificado em nuvem da Valid.', icon: 'bi bi-cloud-check' },
        token: { title: 'Certificado A3', description: 'Assinar com o token físico conectado ao computador.', icon: 'bi bi-usb-symbol' },
        none: { title: 'Continuar sem assinatura digital', description: 'Gerar o documento sem assinar digitalmente.', icon: 'bi bi-file-earmark-text' },
      };
      return options[certifier.id] || { title: certifier.description, description: 'Usar este certificado para assinar.', icon: 'bi bi-pen' };
    },
    go(certifier) {
      if (this.disabled) return;
      this.selectedCertifier = certifier.id;
      this.$store.state.auth.certifier = certifier;
      this.$emit("onSelect", certifier);
    }
  },
}

</script>

<style scoped>
.certificate-dialog { max-width: 520px; }
.certificate-hint { margin: 0 0 16px; color: #706b79; font-size: 13px; }
.certificate-options { display: flex; flex-direction: column; gap: 10px; }
.certificate-option { display: flex; align-items: center; gap: 14px; width: 100%; padding: 16px; border: 1px solid #e4dfe8; border-radius: 12px; background: #fff; text-align: left; color: #302b38; cursor: pointer; transition: background .15s, border-color .15s; }
.certificate-option:hover:not(:disabled), .certificate-option.is-selected { background: #fcf6fa; border-color: #b16c9e; }
.certificate-option:focus-visible { outline: 3px solid #ba83ad; outline-offset: 2px; }
.certificate-option:disabled { opacity: .55; cursor: wait; }
.certificate-option__icon { display: grid; place-items: center; flex-shrink: 0; width: 42px; height: 42px; border-radius: 11px; background: #f7edf4; color: #780f5a; font-size: 21px; }
.certificate-option__text { display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0; }
.certificate-option__text strong { font-size: 14px; font-weight: 600; line-height: 1.4; }
.certificate-option__text > span { color: #817b89; font-size: 12px; line-height: 1.5; }
.certificate-option__arrow { flex-shrink: 0; color: #aaa1af; font-size: 13px; }
@media (max-width: 575px) {
  .certificate-option { padding: 12px; gap: 10px; }
}
</style>